import React, { useState } from "react";

import { faDown } from "@performyard/fontawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@performyard/fontawesome/react-fontawesome";
import { ButtonStandard, toast } from "@performyard/py-components";

import RadialProgress from "../../../components.smart/DownloadButton/RadialProgress";

import type { WorkflowTodoFilterParams } from "../../../api/services/defs/workflows";
import { downloadWorkflowTodosCsv } from "../../../api/services/defs/workflows";

const CSV_FILENAME = "workflow-to-dos.csv";

type DownloadTodosCsvButtonProps = {
	params: WorkflowTodoFilterParams;
};

const DownloadTodosCsvButton = ({ params }: DownloadTodosCsvButtonProps) => {
	const [isDownloading, setIsDownloading] = useState(false);

	const handleDownload = async () => {
		if (isDownloading) {
			return;
		}
		setIsDownloading(true);
		try {
			const blob = await downloadWorkflowTodosCsv(params);
			const url = URL.createObjectURL(blob);
			const anchor = document.createElement("a");
			anchor.href = url;
			anchor.download = CSV_FILENAME;
			document.body.appendChild(anchor);
			anchor.click();
			anchor.remove();
			URL.revokeObjectURL(url);
		} catch {
			toast.error("There was an error downloading the CSV.");
		} finally {
			setIsDownloading(false);
		}
	};

	return (
		<ButtonStandard
			data-testid="downloadCsvButton"
			variant="outline"
			color="neutral"
			disabled={isDownloading}
			dangerouslySetClassName="w-auto"
			onClick={handleDownload}
		>
			<div className="flex items-center gap-2">
				<div className="relative h-[22px] w-[22px] rounded-full">
					<div
						className={`absolute inset-0 z-10 flex items-center justify-center text-xs ${
							isDownloading ? "text-primary-5" : "text-neutral-3"
						}`}
					>
						<FontAwesomeIcon icon={faDown} />
					</div>
					<RadialProgress size={22} strokeWidth={2} percentage={0} />
				</div>

				<span>{isDownloading ? "Downloading..." : "Download CSV"}</span>
			</div>
		</ButtonStandard>
	);
};

export default DownloadTodosCsvButton;
